import "core-js/modules/es.symbol";
import "core-js/modules/es.array.filter";
import "core-js/modules/es.array.for-each";
import "core-js/modules/es.object.get-own-property-descriptor";
import "core-js/modules/es.object.get-own-property-descriptors";
import "core-js/modules/es.object.keys";
import "core-js/modules/web.dom-collections.for-each";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(source, true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(source).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

//
//
//
//
//
//
//
//
//
//
//
import store from '@/vue/store';
import qs from 'query-string';
import moment from 'moment';
import _ from 'lodash';
import { mapActions } from 'vuex';
import MenuList from './menu-list.vue';
import SelectGenre from './select-genre.vue';
import RecommendList from './recommend-list.vue';
var namespace = 'shopmenu-store';
export default {
  store: store,
  components: {
    MenuList: MenuList,
    SelectGenre: SelectGenre,
    RecommendList: RecommendList
  },
  props: {
    basename: String
  },
  methods: _objectSpread({}, mapActions(namespace, ['getMenuList', 'getRecommendList'])),
  mounted: function mounted() {
    this.getMenuList(this.basename);
    this.getRecommendList(this.basename);
  }
};